import DotNetInstall from "../../../../contents/docs/integrate/_snippets/install-dotnet.mdx";
import DotNetSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-dotnet.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import DotNetFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-dotnet.mdx";
import LocalEvaluationIntro from "../../../../contents/docs/feature-flags/snippets/local-evaluation-intro.mdx";
import * as React from 'react';
export default {
  DotNetInstall,
  DotNetSendEvents,
  FeatureFlagsLibsIntro,
  DotNetFeatureFlagsCode,
  LocalEvaluationIntro,
  React
};